/**
 * Created by Ning Jiang on 2022-01-13.
 */

import {IdleAnimationController} from "./IdleAnimationController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class IdleAnimationManager {

    private readonly _idleAnimations:IdleAnimationController[];

    constructor(idleAnimations:IdleAnimationController[]) {
        this._idleAnimations = idleAnimations;
    }

    public start():void {
        Logger.logDev(`start idle`);
        this._idleAnimations.forEach(animation => animation.start());
    }

    public stop():void {
        Logger.logDev(`stop idle`);
        this._idleAnimations.forEach(animation => animation.stop());
    }
}